import React, { PureComponent } from 'react'
import { arrayOf, shape, string, object, func } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { getFontStyles } from '@ycos/primitives'

class Dropdown extends PureComponent {
  static renderCustomOptions = ({ items, valueField = 'value', labelField = 'label' }) =>
    items.map((option, i) => {
      const value = option[valueField]
      const label = option[labelField]

      return (
        <option value={value} key={`option-${i}-${value}`}>
          {label}
        </option>
      )
    })

  static renderCMOptions = (items) =>
    items.map((option, i) => {
      const { teaserTitle: label, key } = option.props.item
      const value = key || label

      return (
        <option value={value} key={`option-${i}-${value}`}>
          {label}
        </option>
      )
    })

  static layoutVariant = 'isc-dropdown'

  render() {
    const { children, defaultValue, item, options, placeholder, selectRef } = this.props
    const placeholderText = (!defaultValue && placeholder) || (item && item.teaserTitle)

    return (
      <div data-automation="dropdown">
        <SelectWrapper>
          <Select required defaultValue={defaultValue} ref={selectRef}>
            {placeholderText && (
              <Placeholder value="" selected disabled>
                {placeholderText}
              </Placeholder>
            )}
            {options ? Dropdown.renderCustomOptions(options) : Dropdown.renderCMOptions(children)}
          </Select>
        </SelectWrapper>
      </div>
    )
  }
}

Dropdown.propTypes = {
  item: shape({
    layoutVariant: string.isRequired,
    teaserTitle: string
  }).isRequired,
  children: arrayOf(
    shape({
      key: string,
      teaserTitle: string.isRequired
    })
  ).isRequired,
  selectRef: func,
  placeholder: string,
  defaultValue: string,
  options: shape({
    valueField: string,
    labelField: string,
    items: arrayOf(object).isRequired
  })
}

export default Dropdown

const SelectWrapper = createComponent('SelectWrapper', ({ theme }) => ({
  direction: 'ltr',
  position: 'relative',
  width: '100%',
  ':before': {
    content: '""',
    width: '9px',
    height: '9px',
    borderTop: `1px solid ${theme.custom.dropdown.color}`,
    borderRight: `1px solid ${theme.custom.dropdown.color}`,
    position: 'absolute',
    right: `${2 * theme.spacingMultiplier}px`,
    top: `${2 * theme.spacingMultiplier}px`,
    transform: 'rotate(135deg)',
    pointerEvents: 'none'
  }
}))

const Select = createComponent(
  'Select',
  ({ theme }) => {
    const typographyStyles = getFontStyles(theme.typography, { type: 'Label', tagName: 'select', name: '1' })
    const {
      spacingMultiplier,
      custom: { dropdown }
    } = theme
    const baseStyles = {
      appearance: 'none',
      background: 'transparent',
      border: `1px solid ${dropdown.borderColor}`,
      borderRadius: '2px',
      color: dropdown.color,
      height: '48px',
      width: '100%',
      padding: `0 ${5 * spacingMultiplier}px 0 ${2 * spacingMultiplier}px`,
      textAlign: 'left',
      ':hover': {
        border: `1px solid ${dropdown.hover.borderColor}`
      },
      ':active': {
        border: `1px solid ${dropdown.active.borderColor}`
      },
      ':focus': {
        border: `1px solid ${dropdown.active.borderColor}`,
        outline: 'none'
      },
      '::-ms-expand': {
        display: 'none'
      },
      ':-moz-focusring': {
        color: 'transparent',
        textShadow: `0 0 0 ${dropdown.color}`
      }
    }

    return {
      ...typographyStyles,
      ...baseStyles
    }
  },
  'select',
  ['required']
)

const Placeholder = createComponent(
  'Placeholder',
  () => ({
    display: 'none'
  }),
  'option',
  ['disabled', 'selected']
)
